<div id="address_info_section_showcase" [formGroup]='group'>
  <div class="form-field-section">
    <edit-input class="editIcon" (emitInputUpdate)="updateResource($event)" [iconClass]="addressResourceInfo.IconClass"
      [viewName]="addressResourceInfo.Title"></edit-input>
    <mat-form-field class="fullWidth" floatLabel="always">
      <mat-label>{{addressResourceInfo.PlaceHolder}} <mat-icon matTooltipPosition="above" class="mat-form-field-label-icon" *ngIf="addressResourceInfo?.ToolTip" matTooltipClass="label-tooltip"  matTooltip="{{addressResourceInfo.ToolTip}}">{{addressResourceInfo.IconClass?addressResourceInfo.IconClass:defaultTootipIcon}}</mat-icon></mat-label>
      <input  google-places formControlName="MailingAddress" maxlength="{{addressResourceInfo.MaxValue}}" matInput  #placesRef="ngx-google-places"
       [options]="googlePlacesOptions"
        (onAddressChange)="handleAddressChange($event)"
        [placeholder]="addressResourceInfo.Watermark" 
        [mask]="addressResourceInfo.MaskRegex" [required]="addressResourceInfo.IsRequired" [attr.data-id]="getMailingAddressId()" />
        <mat-hint class="hyperlink-mat-hint" *ngIf="!showAddressLine2">
        <a [routerLink]="" (click)="addAddressLine2()">
          <adp-label id="midsize" labelKey="CustomerInfo_AddressLine2"></adp-label>
        </a>
      </mat-hint>
      <mat-error class="error" *ngIf="AddressField.errors?.required">
        <span [innerHtml]='addressResourceInfo.ValidationMessage? addressResourceInfo.ValidationMessage:
            (resourceService.getViewLabel("Global_Text_VMRequired") | safeHtml)'>
        </span>
      </mat-error>
      <mat-error class="error" *ngIf="AddressField.errors?.pattern">
        <span [innerHtml]='addressResourceInfo.ValidationMessage ? addressResourceInfo.ValidationMessage :
              resourceService.getViewLabel("Global_Text_VMPattern")'>
        </span>
      </mat-error>
      <mat-error class="error" *ngIf="AddressField.errors?.minlength">
        <span [innerHtml]='addressResourceInfo.ValidationMessage ? addressResourceInfo.ValidationMessage :
            resourceService.getViewLabel("Global_Text_VMMinLength")'>
        </span>
      </mat-error>
      <mat-error class="error" *ngIf="AddressField.errors?.maxlength">
        <span [innerHtml]='addressResourceInfo.ValidationMessage ? addressResourceInfo.ValidationMessage :
              resourceService.getViewLabel("Global_Text_VMMaxLength")'>
        </span>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-field-section" *ngIf="showAddressLine2">
    <adp-input [componentName]="componentName" [resourceData]="mailingAddress2ResourceField"
      formControlName="{{this.mailingAddress2ControlName}}" class="fullWidth"></adp-input>
  </div>

  <div class="form-field-section">
    <adp-input [componentName]="componentName" [resourceData]="cityResourceField"
      formControlName="{{this.cityControlName}}" class="fullWidth m-r-5"></adp-input>
    <adp-select *ngIf="!stateResourceField.Hidden" [componentName]="componentName" [resourceData]="stateResourceField"
      [listItems]="states" formControlName="{{this.stateControlName}}" class="fullWidth m-r-5"></adp-select>
    <adp-input [componentName]="componentName" [resourceData]="zipCodeResourceField"
      formControlName="{{this.zipCodeControlName}}" class="fullWidth m-r-5"></adp-input>
    <adp-select [componentName]="componentName" [resourceData]="countryResourceField" [listItems]="countries"
      formControlName="{{this.countryControlName}}" class="fullWidth"></adp-select>
  </div>
</div>